'use client';

import { Typography } from 'components';
import { AiSubStep, AiSubStepTypeEnum } from 'gql/graphql';
import { useTranslations } from 'next-intl';
import { FC, PropsWithChildren } from 'react';

const GeneralSubStepRun: FC<PropsWithChildren<AiSubStep>> = ({ type, content, sourceId }) => {
  const t = useTranslations();

  return (
    <>
      {type === AiSubStepTypeEnum.System && (
        <div className="flex pt-2">
          <Typography variant="regular5" className="w-4/5 text-tertiary-200">
            {t('labels.system_prompt')}:
          </Typography>
          <Typography variant="regular5" className="w-full !leading-4 text-tertiary-100">
            {content?.value}
          </Typography>
        </div>
      )}
      {type === AiSubStepTypeEnum.Custom && (
        <div className="flex pt-2">
          <Typography variant="regular5" className="w-4/5 text-tertiary-200">
            {t('labels.custom_prompt')}:
          </Typography>
          <Typography variant="regular5" className="w-full !leading-4 text-tertiary-100">
            {content?.value}
          </Typography>
        </div>
      )}
      {type === AiSubStepTypeEnum.Engine && (
        <div className="flex pt-2">
          <Typography variant="regular5" className="w-4/5 text-tertiary-200">
            {t('labels.engine')}:
          </Typography>
          <Typography variant="regular5" className="w-full !leading-4 text-tertiary-100">
            {t(`engines.${content?.value}` as any)}
          </Typography>
        </div>
      )}
      {type === AiSubStepTypeEnum.Temperature && (
        <div className="flex pt-2">
          <Typography variant="regular5" className="w-4/5 text-tertiary-200">
            {t('labels.temperature')}:
          </Typography>
          <Typography variant="regular5" className="w-full !leading-4 text-tertiary-100">
            {content?.value}
          </Typography>
        </div>
      )}
    </>
  );
};

export default GeneralSubStepRun;
